<template>
  <main
    :class="useRoute().meta?.fillHeight ? 'FillHeight' : ''"
  >
    <template v-if="useAuthStore().isLoggedIn">
      <div
        v-if="useRoute().meta?.lightBackground"
        class="layout-fixed-bg bg-light"
      />

      <OperatorAppHeader />

      <slot />

      <OperatorChats class="OperatorChats" />

      <RequestForwardDialog />
      <RequestChooseAssistantDialog />
      <OperatorRequestForwardInfoBox />
      <OperatorRequestAssistantAccept />
      <OperatorCallingBox v-if="useOperatorCallingStore().number && useOperatorCallingStore().token" />
      <OperatorRequestsSoundNotifications />
      <OperatorRequestsTabBadge />
      <ConfirmRequestAcceptDialog />
    </template>
    <div
      v-else
      v-loading="true"
      class="min-h-20"
    />
  </main>
</template>

<style scoped>
main {
  &.FillHeight {
    padding-bottom: 0;
    height: 100vh;
    height: 100dvh;
    overflow: hidden;

    display: flex;
    flex-direction: column;

    /* iOS without dvh support (< 15.4) */
    @supports (-webkit-touch-callout: none) and (not (height: 100dvh)) {
      @media (min-height: 450px) {
        max-height: -webkit-fill-available;
      }
    }
  }

  .OperatorChats {
    position: fixed;
    bottom: 0;
  }
}

main.FillHeight :deep(.page) {
  padding-bottom: 0;
  min-height: 0; /* .page min-height is 100vh-based, taller than 100dvh */
}
</style>
